import React, { useEffect, useState, useRef } from 'react';
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from 'reactstrap';
import { IMediaData } from '../../../../modules/dobbies-media-gallery/utils/helper';

interface ICustomCarouselProps {
    mediaGalleryItems: IMediaData[];
    onNext?: () => void;
    onPrevious?: () => void;
    onGoToIndex?: (index: number) => void;
    thumbnailActiveIndex?: number;
}

export function CustomCarousel(props: ICustomCarouselProps) {
    const { mediaGalleryItems, thumbnailActiveIndex, onNext, onPrevious, onGoToIndex } = props;

    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const startX = useRef(0);
    const startY = useRef(0);
    const isHorizontalSwipe = useRef(false);

    const handleTouchStart = (e: React.TouchEvent) => {
        startX.current = e.touches[0].clientX;
        startY.current = e.touches[0].clientY;
        isHorizontalSwipe.current = false;
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        const dx = Math.abs(e.touches[0].clientX - startX.current);
        const dy = Math.abs(e.touches[0].clientY - startY.current);

        if (dx > dy) {
            isHorizontalSwipe.current = true;
            e.preventDefault(); // stop page scroll
        }
    };

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === mediaGalleryItems.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
        onNext && onNext();
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? mediaGalleryItems.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
        onPrevious && onPrevious();
    };

    const goToIndex = (newIndex: number) => {
        if (animating) return;
        setActiveIndex(newIndex);
        onGoToIndex && onGoToIndex(newIndex);
    };

    useEffect(() => {
        if (thumbnailActiveIndex !== undefined && thumbnailActiveIndex !== activeIndex) {
            goToIndex(thumbnailActiveIndex);
        }
    }, [thumbnailActiveIndex]);

    const slides = mediaGalleryItems.map((item, index) => (
        <CarouselItem tag='div' key={index} onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)}>
            <img src={item.src} alt={item.altText} />
        </CarouselItem>
    ));

    return (
        <div className='ms-media-gallery__carousel' onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
            <Carousel activeIndex={activeIndex} next={next} previous={previous} interval={false}>
                {/* @ts-ignore */}
                <CarouselIndicators items={mediaGalleryItems} activeIndex={activeIndex} onClickHandler={goToIndex} />
                {slides}
                {mediaGalleryItems.length > 1 ? (
                    <>
                        <CarouselControl direction='prev' directionText='Previous' onClickHandler={previous} />
                        <CarouselControl direction='next' directionText='Next' onClickHandler={next} />
                    </>
                ) : null}
            </Carousel>
        </div>
    );
}
